const WORDS = ["Lomo Saltado", "Ceviche", "Chifa", "Anticuchos", "Inca Kola", "Tallarín Verde", "Cau Cau", "Chicha Morada"];

export default function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <div className="bg-[#da251d] py-5 md:py-6 overflow-hidden select-none" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-white text-2xl md:text-4xl px-8">{w}</span>
            <span className="text-white/50 text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
